import { useQuery } from "@tanstack/react-query";

import { PendingCoverCropSuggestion, getPendingCoverCropDetections } from "services";

import { GET_PENDING_COVER_CROP_DETECTIONS } from "consts";

export const useGetPendingCoverCropDetections = ({ farmId, enabled = true }: { farmId?: string; enabled?: boolean }) =>
  useQuery<PendingCoverCropSuggestion[]>({
    queryKey: [GET_PENDING_COVER_CROP_DETECTIONS, farmId],
    queryFn: getPendingCoverCropDetections,
    staleTime: 60_000,
    enabled: enabled && !!farmId,
  });
